<div class="pssr-page">
  <header class="portal-header">

    <div class="portal-header__center">
      <img class="portal-header__logo" src="https://cdn-nextpage.chevron.com/img/favicon.gif" alt="Chevron" />
      <h1 class="portal-header__title">{{ title() }}</h1>
    </div>

    <div class="portal-header__right">
      @if (isAuthenticated()) {
        <span class="portal-header__email">{{ userEmail() }}</span>
      }
    </div>
  </header>

  <div class="portal-strip" aria-hidden="true"></div>

  <section class="pssr-page-content">
    <mat-card class="portal-card">
      <mat-card-content>
        @if (isAuthenticating()) {
          <div class="loading-container">
            <mat-spinner diameter="48"></mat-spinner>
            <div class="empty-state">Authenticating...</div>
          </div>
        } @else if (!isAuthenticated()) {
          <div class="signin-container">
            <h2 class="signin-title">Sign in required</h2>
            <p class="signin-message">You must authenticate to view and manage feature flags.</p>
            @if (authErrorMessage()) {
              <p class="signin-error">{{ authErrorMessage() }}</p>
            }
            <button mat-raised-button color="primary" (click)="signIn()">Sign in</button>
          </div>
        } @else if (isLoading()) {
          <div class="loading-container">
            <mat-spinner diameter="48"></mat-spinner>
          </div>
        } @else if (flags().length > 0) {
          <div class="pssr-table-container">
            <table mat-table [dataSource]="flags()" class="flags-table pssr-table">
              <ng-container matColumnDef="featureName">
                <th mat-header-cell *matHeaderCellDef>feature name</th>
                <td mat-cell *matCellDef="let flag">
                  <div class="flag-name">{{ flag.featureName }}</div>
                </td>
              </ng-container>

              <ng-container matColumnDef="enabled">
                <th mat-header-cell *matHeaderCellDef>enabled</th>
                <td mat-cell *matCellDef="let flag">
                  <mat-slide-toggle
                    [checked]="flag.enabled"
                    [disabled]="isFlagSaving(flag.featureName)"
                    (change)="toggleFlag(flag, $event)"
                    [attr.aria-label]="flag.featureName + ' toggle'"
                  ></mat-slide-toggle>
                </td>
              </ng-container>

              <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef>label</th>
                <td mat-cell *matCellDef="let flag">
                  <span class="metadata-pill">{{ flag.label }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="updatedAt">
                <th mat-header-cell *matHeaderCellDef>updated</th>
                <td mat-cell *matCellDef="let flag">{{ flag.updatedAt }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
        } @else {
          <div class="empty-state">No feature flags available.</div>
        }
      </mat-card-content>
    </mat-card>
  </section>
</div>



